/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link } from 'react-router-dom';
import MainHeader from '../header';
import MealtristHeader from '../Core/mealtristHeader';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import StackGrid from "react-stack-grid";
import mealpic from '../../assets/img/mealtrist-featured-meal.jpg'
import '../../App.css';
import 'font-awesome/css/font-awesome.css';
import profilePic from '../../assets/img/profile-pic.png';
import swal from 'sweetalert';
import MealtristFooter from "../Core/mealtrist-footer";

class Connections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {firstName: "", lastName: "", userId: "", email: "", userName: "", friendType: "Connection", password: "", grid: "", searchForFriends: "", approveFriends: "", friends: "", search: "", loggedIn: true, savedMeal: "", redirecting: false, provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
        this.handleChange = this.handleChange.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.createMarkup = this.createMarkup.bind(this);
        this.capitalizeWords = this.capitalizeWords.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.triggerChange = this.triggerChange.bind(this);
        this.sendFriendRequest = this.sendFriendRequest.bind(this);
        this.onSelectAlert = this.onSelectAlert.bind(this);
    }

    componentWillMount() {
        this.timer = null;
    }

    onSelectAlert(e, event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.getAttribute('data-value');

        this.setState({[currentId]: currentValue});
        if(this.state.userId !== "") {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/connections/relationship',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            userId: response.data.id,
                                            friendId: currentId,
                                            relationship: currentValue
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log(response);
                                            // if (typeof(response) !== 'undefined') {
                                            //     globalThis.setState(prevState => ({
                                            //         searchForFriends: response.friends
                                            //     }));
                                            // }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }

    }

    handleSearchChange(event) {
        var globalThis = this;
        clearTimeout(this.timer);

        //clear search results for friends
        this.setState({ search:event.target.value.toLowerCase() });

        this.timer = setTimeout(globalThis.triggerChange, 500);
    }

    handleKeyDown(e) {
        var globalThis = this;
        if (e.keyCode === 13) {
            globalThis.triggerChange();
        }
    }

    triggerChange() {
        if(this.state.search !== "") {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/connections/search',
                                        type: 'post',
                                        async: false,
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log(response);
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    searchForFriends: response.friends
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        } else {
            this.setState(prevState => ({
                searchForFriends: ""
            }));
        }
    }

    handleChange(event) {
        this.setState({search: event.target.value.toLowerCase()});
    }

    handlePassword(e) {
        this.setState({password: e.target.value});
    }

    capitalizeWords(str)
    {
        if(typeof(str) !== "undefined") {
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }
    }

    sendFriendRequest(username, userId, friendUsername, friendId, deny)
    {
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if(user.token != "" ) {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if(typeof(response.message) !== 'undefined') {
                        if(response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/connections/request',
                                    type: 'post',
                                    async: false,
                                    data: {
                                        username: username,
                                        userId: userId,
                                        friendUsername: friendUsername,
                                        friendId: friendId,
                                        deny: deny
                                    },
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        console.log(response);
                                        if(typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                friends: response.profiles
                                            }));
                                            globalThis.setState(prevState => ({
                                                userId: response.user.id
                                            }));
                                            globalThis.setState(prevState => ({
                                                firstName: response.user.first_name
                                            }));
                                            globalThis.setState(prevState => ({
                                                lastName: response.user.last_name
                                            }));
                                            globalThis.setState(prevState => ({
                                                userName: response.user.username
                                            }));
                                            globalThis.setState(prevState => ({
                                                email: response.user.email
                                            }));
                                            globalThis.setState(prevState => ({
                                                searchForFriends: response.friends
                                            }));
                                            globalThis.setState(prevState => ({
                                                approveFriends: response.approve
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }
    }

    createMarkup(text) {
        return {__html: text};
    }

    componentDidMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        if(user.token != "" ) {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if(typeof(response.message) !== 'undefined') {
                        if(response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                if (typeof(response.data.id) !== 'undefined') {

                                } else {
                                    globalThis.setState(prevState => ({
                                        loggedIn: false
                                    }));
                                }
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/connections/show',
                                    type: 'post',
                                    async: false,
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        console.log(response);
                                        if(typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                friends: response.profiles
                                            }));
                                            globalThis.setState(prevState => ({
                                                userId: response.user.id
                                            }));
                                            globalThis.setState(prevState => ({
                                                firstName: response.user.first_name
                                            }));
                                            globalThis.setState(prevState => ({
                                                lastName: response.user.last_name
                                            }));
                                            globalThis.setState(prevState => ({
                                                userName: response.user.username
                                            }));
                                            globalThis.setState(prevState => ({
                                                email: response.user.email
                                            }));
                                            globalThis.setState(prevState => ({
                                                approveFriends: response.approve
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }

    }

    //TODO set referrer url link in containers first child link
    render() {
        const grid = {
            update: ""
        }
        const fakeArr = ["d", "a"];
        const pictures = fakeArr.map((imgPath, pathIndex) => {
            return  <div key={imgPath}><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>
        });
        const header = {
            use: ""
        }
        if(this.state.loggedIn === true) {
            header.use = <MealtristHeader/>;
        } else {
            header.use = <MainHeader/>;
        }

        let output =
            <div>
                {header.use}
                <div className="text-center main-body-content">
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                </div>
                <MealtristFooter/>
            </div>
            if(this.state.friends !== "" || this.state.searchForFriends !== "" || this.state.approveFriends !== "") {
                console.log("in friends section");
                console.log(this.state.friends);
                let existingFriends = "";
                let searchFriends = "";
                let approveFriends = "";
                if(this.state.searchForFriends !== "") {
                    console.log("searchforFriends");
                    console.log(this.state.searchForFriends);
                    searchFriends = this.state.searchForFriends.filter((friend) => friend.full_name.toLowerCase().indexOf(this.state.search) > -1);
                    searchFriends = searchFriends.map((friend, mealIndex) => {
                        return <div key={mealIndex}>
                            {friend.picture === "" &&
                            <img className="center-block img-responsive img-circle" width="75" height="75"
                                 src={profilePic}/>
                            }
                            {friend.picture !== "" &&
                            <img className="center-block img-responsive"
                                 src={'http://www.mealtrist.com/public/mealpics/' + friend.picture}/>
                            }
                            <h4 className="text-center">{friend.first_name + " " + friend.last_name}</h4>
                            <p className="text-center">{friend.city}</p>
                            <div className="row">
                                <div className="col-sm-3"></div>
                                {friend.user_a_id === this.state.userId &&
                                <div className="col-sm-6">
                                    <ReactBootstrap.ButtonToolbar>
                                        <ReactBootstrap.Button bsSize="small">Awaiting Response</ReactBootstrap.Button>
                                    </ReactBootstrap.ButtonToolbar>
                                </div>
                                }
                                {friend.user_a_id !== this.state.userId &&
                                <div className="col-sm-6">
                                    <ReactBootstrap.ButtonToolbar>
                                        <ReactBootstrap.Button bsSize="small" onClick={this.sendFriendRequest.bind(this, this.state.userName, this.state.userId, friend.username, friend.user_id, 0)}>Request Connection</ReactBootstrap.Button>
                                    </ReactBootstrap.ButtonToolbar>
                                </div>
                                }
                                <div className="col-sm-3"></div>
                            </div>
                        </div>
                    });
                }
                if(this.state.approveFriends !== "") {
                    if(this.state.approveFriends.length > 0) {
                        approveFriends = this.state.approveFriends.map((friend, mealIndex) => {
                            return <div key={mealIndex}>
                                {friend.picture === "" &&
                                <img className="center-block img-responsive img-circle" width="75" height="75"
                                     src={profilePic}/>
                                }
                                {friend.picture !== "" &&
                                <img className="center-block img-responsive"
                                     src={'http://www.mealtrist.com/public/mealpics/' + friend.picture}/>
                                }
                                <h4 className="text-center">{friend.first_name + " " + friend.last_name}</h4>
                                <p className="text-center">{friend.city}</p>
                                <div className="row">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-6">
                                        <ReactBootstrap.ButtonToolbar>
                                            <ReactBootstrap.Button bsSize="small"
                                                                   onClick={this.sendFriendRequest.bind(this, this.state.userName, this.state.userId, friend.username, friend.user_id, 0)}>Accept Request</ReactBootstrap.Button>
                                        </ReactBootstrap.ButtonToolbar>
                                    </div>
                                    <div className="col-sm-3"></div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-6">
                                        <ReactBootstrap.ButtonToolbar>
                                            <ReactBootstrap.Button bsSize="small"
                                                                   onClick={this.sendFriendRequest.bind(this, this.state.userName, this.state.userId, friend.username, friend.user_id, 1)}>Deny Request</ReactBootstrap.Button>
                                        </ReactBootstrap.ButtonToolbar>
                                    </div>
                                    <div className="col-sm-3"></div>
                                </div>
                            </div>
                        });
                    } else {
                        approveFriends = "";
                    }
                }

                if(this.state.friends !== "") {
                    // existingFriends = this.state.friends.filter((friend) => friend.full_name.toLowerCase().indexOf(this.state.search) > -1);
                    existingFriends = this.state.friends.map((friend, mealIndex) => {
                        let relationshipTitle = "";
                        if(typeof(this.state[friend.user_id]) !== "undefined") {
                            relationshipTitle = this.state[friend.user_id];
                        } else {
                            if(friend.relationship !== "" || friend.relationship !== null) {
                                relationshipTitle = friend.relationship;
                            } else {
                                relationshipTitle = "Friend";
                            }
                        }
                        return <div key={mealIndex}>
                            {friend.picture === "" &&
                            <img className="center-block img-responsive img-circle" width="75" height="75"
                                 src={profilePic}/>
                            }
                            {friend.picture !== "" &&
                            <img className="center-block img-responsive"
                                 src={'http://www.mealtrist.com/public/mealpics/' + friend.picture}/>
                            }
                            <h4 className="text-center">{friend.first_name + " " + friend.last_name}</h4>
                            <p className="text-center">{friend.city}</p>
                            <div className="row">
                                <div className="col-sm-3"></div>
                                <div className="col-xs-6">
                                    <ReactBootstrap.Form horizontal>
                                        <ReactBootstrap.FormGroup bsSize="small" controlId="formHorizontalEmail">
                                            <ReactBootstrap.SplitButton title={this.capitalizeWords(relationshipTitle)} pullRight id="split-button-pull-right" bsSize="small">
                                                <ReactBootstrap.MenuItem data-id={friend.user_id} data-value={"Family"} value={"test"} onSelect={this.onSelectAlert}>Family</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem data-id={friend.user_id} data-value={"Close Friends"} value={"test"} onSelect={this.onSelectAlert}>Close Friends</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem data-id={friend.user_id} data-value={"Follower"} value={"test"} onSelect={this.onSelectAlert}>Follower</ReactBootstrap.MenuItem>
                                                <ReactBootstrap.MenuItem data-id={friend.user_id} data-value={"Viewer"} value={"test"} onSelect={this.onSelectAlert}>Viewer</ReactBootstrap.MenuItem>
                                            </ReactBootstrap.SplitButton>
                                        </ReactBootstrap.FormGroup>
                                    </ReactBootstrap.Form>
                                </div>
                                <div className="col-sm-3"></div>
                            </div>
                        </div>
                    });
                }
                console.log("print meals");
                console.log(this.state.firstName + ' ' +  this.state.lastName + " " + this.state.email + " " + this.state.userName + " " + this.state.userId);
                console.log(this.state.friends);
                output = <div>
                    <div className="container main-body-content">
                        {header.use}
                        <div className="row">
                            <div className="col-xs-3"></div>
                            <div className="col-xs-6">
                                <ReactBootstrap.Form horizontal>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                    <ReactBootstrap.FormControl type="text" value={this.state.search} onChange={this.handleSearchChange}
                                                                onKeyDown={this.handleKeyDown} placeholder="Search For Friends" />
                                    </ReactBootstrap.FormGroup>
                                </ReactBootstrap.Form>
                            </div>
                            <div className="col-xs-3"></div>
                        </div>
                        {searchFriends !== "" &&
                        <div claassName="row">
                            <h2 className="text-center">Search Results:</h2>
                        </div>
                        }
                        {searchFriends !== "" &&
                        <StackGrid
                            columnWidth={"25%"}
                            monitorImagesLoaded="{true}"
                            // duration={0}
                        >
                            {searchFriends}
                        </StackGrid>
                        }
                        {searchFriends !== "" &&
                        <hr></hr>
                        }

                        {approveFriends !== "" &&
                        <div claassName="row">
                            <h2 className="text-center">Needing Your Approval:</h2>
                        </div>
                        }
                        {approveFriends !== "" &&
                        <StackGrid
                            columnWidth={"25%"}
                            monitorImagesLoaded="{true}"
                            // duration={0}
                        >
                            {approveFriends}
                        </StackGrid>
                        }
                        {approveFriends !== "" &&
                        <hr></hr>
                        }

                <StackGrid
                    columnWidth={"25%"}
                    monitorImagesLoaded="{true}"
                    // duration={0}
                >
                    {existingFriends}
                    {/*{pictures}*/}
                    {/*<div key="key1"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>*/}
                    {/*<div key="key2"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo02.jpg" /></div>*/}
                    {/*<div key="key3"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /> </div>*/}
                    {/*<div key="key4"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo02.jpg" /></div>*/}
                    {/*<div key="key5"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>*/}
                    {/*<div key="key6"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo02.jpg" /></div>*/}
                    {/*<div key="key7"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /> </div>*/}

                </StackGrid>
                    </div>
                    <MealtristFooter/>
                </div>
            }
        // console.log("print grid");
        // console.log(grid.update);
        // if(grid.update !== "") {
        //     console.log("grid updating");
        //     console.log(grid.update);
        //     grid.update.updateLayout();
        // }
        return (

                output

        );
    }
}

export default Connections;


// WEBPACK FOOTER //
// ./src/components/Mealtrist/connections.js